// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCroppie from 'vue-croppie'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueQuillEditor from 'vue-quill-editor'
import VueSocketio from 'vue-socket.io-extended'
import VueYoutube from 'vue-youtube'
// import Rollbar from 'vue-rollbar'
import io from 'socket.io-client'
import router from './router'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import store from '@/store'
import '@fortawesome/fontawesome-free/css/all.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'croppie/croppie.css'
import 'intro.js/introjs.css'
import './styles/keybe.scss'
import './styles/kb-tables.scss'
import './styles/countries.css'
import './styles/Charts/charts.scss'
import 'highlight.js/styles/github.css'
import 'moment/locale/es'
import { UrlBase } from '@/services/config'
import formatNumber from '@/libs/formatNumber'
import '@/assets/feather_icons/feather.css'
import SimpleFlowchart from 'vue-simple-flowchart'
import 'vue-simple-flowchart/dist/vue-flowchart.css'
// importing the helper to intercept axios reqs and resp
import interceptorsSetup from '@/libs/helpers/interceptors'
// components
import VueIntro from 'vue-introjs'
import VueHighlightJS from 'vue-highlightjs'
import VueCodeHighlight from 'vue-code-highlight'
import Snotify from 'vue-snotify'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import VCreditCard from 'v-credit-card'
import 'v-credit-card/dist/VCreditCard.css'
import Vue2Filters from 'vue2-filters'
import VueMask from 'v-mask'
import apolloProvider from '@/plugins/graphql/grahql.js'
import VueTelInput from 'vue-tel-input'
import InlineEditor from '@/components/widgets/InlineEditor'

Vue.component('v-credit-card', VCreditCard)

Vue.use(Snotify)
// axios setup
Vue.use(VueAxios, axios)
interceptorsSetup(store)

Vue.use(VueMask)
Vue.use(VueTelInput)

Vue.use(VueCroppie)
Vue.use(VueMoment, {
  moment
})

Vue.use(money, { precision: 4 })
Vue.use(VueTheMask)
Vue.use(Vue2Filters)

Vue.component('InlineEditor', InlineEditor)
Vue.use(VueYoutube)

// https://github.com/brockpetrie/vue-moment/issues/75#issuecomment-408437967
Vue.filter('nullToDateNow', function (value) {
  // method to set default date to now
  return (value === null || value === undefined) ? moment() : value
})
Vue.filter('toFixed', function (number, decimals) {
  if (decimals === null || decimals === undefined) decimals = 4
  // method to format large numbers
  const formatted = parseFloat(number).toFixed(decimals)
  return formatted
})
Vue.use(VueQuillEditor, {
  placeholder: 'Ingresa la descripción aquí'
})

// Vue.use(Rollbar, {
//   accessToken: '7fd1608a73524037ab179d6e3822a1d5',
//   captureUncaught: false,
//   captureUnhandledRejections: false,
//   enabled: true,
//   environment: process.env.VUE_APP_NODE_ENV,
//   payload: {
//     client: {
//       javascript: {
//         code_version: '1.1.1',
//         source_map_enabled: true,
//         guess_uncaught_frames: true
//       }
//     }
//   }
// })

Vue.use(VueSocketio, io(UrlBase, { path: '/keybesocket' }), { store })

Vue.use(VueIntro)
Vue.use(VueCodeHighlight)
Vue.use(VueHighlightJS)
Vue.filter('formatNumber', formatNumber)
Vue.component('simple-flowchart', SimpleFlowchart)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  vuetify,
  apolloProvider,
  render: h => h(App),
  components: { App }
}).$mount('#app')
